/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { SdsIcon, SdsIconProps } from '../SdsIcon';
import { emptyStateDefaults, EmptyStateProps } from './EmptyState.props';

/**
 * A <EmptyState /> to display an empty state.
 */
export const EmptyState = (props: EmptyStateProps): JSX.Element => {
  const { title, caption, children, classes, dataId, isLite, svg } = {
    ...emptyStateDefaults,
    ...props,
  };

  const cardClass = clsx(`sds-empty-state-card`, classes, {
    [`sds-empty-state-card--lite`]: isLite,
  });
  const sdsIconProps = { classes: 'sds-empty-state-card__icon', svg } as SdsIconProps;

  return (
    <div className={cardClass} data-id={dataId}>
      {svg && <SdsIcon {...sdsIconProps} />}
      {title && <h2 className="sds-empty-state-card__title">{title}</h2>}
      {caption && <span className="sds-empty-state-card__text">{caption}</span>}
      {children}
    </div>
  );
};
